export default __webpack_public_path__ + "static/media/bg-cat-dog-line.02292ba9.png";